import React from 'react';
import { motion } from 'framer-motion';

function SampleAssistantContainer({ title, description, icon, isSelected, onClick }) {
  return (
    <motion.div
      whileHover={{ backgroundColor: '#f9f9f9' }}
      onClick={onClick}
      style={{
        border: isSelected ? '2px solid #2B8E55' : '1px solid #ccc',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: '16px',
        borderRadius: '15px',
        gap: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <div>{icon}</div>
      <div>
        <div
          className="title-style"
          style={{
            color: '#2B8E55',
            fontWeight: '600',
            fontSize: '16px',
            marginBottom: '4px',
          }}
        >
          {title}
        </div>
        <p className="text-xs text-secondary" style={{ margin: 0 }}>
          {description}
        </p>
      </div>
    </motion.div>
  );
}

export default SampleAssistantContainer;
